// frontend/src/api/valuationCompany.ts
//
// VAL-COMPANY-PROFILE-1B — save the engagement's company profile. One PATCH
// endpoint, one client function: this delegates to updateValuationEngagement
// in valuation.ts. The body carries `company_profile` (and, only when passed,
// `industry_facts` and the particulars I1-I9), so it can never touch another
// engagement field. `null` clears the profile.
//
// VAL-PATH-COMPANY (P3): step 1 saves the profile and the particulars in ONE
// PATCH. The two declarations I10-I11 are not in EngagementParticulars, so
// step 1 can never send them.

import { updateValuationEngagement } from '@/api/valuation'
import type { UpdateEngagementBody } from '@/types/valuation'
import type { CompanyProfile, EngagementWithCompany, IndustryFacts } from '@/types/valuationCompany'

export type EngagementParticulars = Pick<
  UpdateEngagementBody,
  | 'prepared_for' | 'premise_of_value' | 'effective_date' | 'purpose' | 'intended_users'
  | 'standard_of_value' | 'subject_interest' | 'interest_characteristics' | 'sources_relied_upon'
>

export async function saveCompanyProfile(
  id: string,
  profile: CompanyProfile | null,
  industryFacts?: IndustryFacts | null,
  particulars?: EngagementParticulars,
): Promise<EngagementWithCompany> {
  // UpdateEngagementBody predates company_profile; widen it here, not there.
  const body: UpdateEngagementBody & { company_profile: CompanyProfile | null; industry_facts?: IndustryFacts | null } =
    { company_profile: profile }
  // Only when passed: undefined leaves the key out, null clears this industry's facts.
  if (industryFacts !== undefined) body.industry_facts = industryFacts
  if (particulars !== undefined) Object.assign(body, particulars)
  return (await updateValuationEngagement(id, body)) as EngagementWithCompany
}
